import { userActivation } from '@the-shared/user-activation';
import { viewActivation } from '@the-shared/view-activation';

export function preFetchScript(
	url: string,
	id: string,
	fetchPriority: 'high' | 'low' | 'auto' = 'low'
) {
	if ( document.getElementById( id ) ) {
		return;
	}

	const link = document.createElement( 'link' );
	link.href = url;
	link.rel = 'prefetch';
	link.as = 'script';
	link.fetchPriority = fetchPriority;

	document.head.appendChild( link );
}

export function loadScript(
	src: string,
	id: string
): Promise< HTMLScriptElement > {
	return new Promise( ( resolve, reject ) => {
		localStorage.setItem( 'the-modification-load-' + id, src );
		const isScript = document.getElementById( id );
		if ( isScript instanceof HTMLScriptElement ) {
			resolve( isScript );
			return;
		}

		const script = document.createElement( 'script' );
		script.src = src;
		script.id = id;
		script.onload = () => resolve( script );
		script.onerror = () => reject();

		document.head.appendChild( script );
	} );
}

export function userActivationLoadScript(
	src: string,
	id: string,
	autoStartTimeOut = 0,
	force: boolean | 'auto' = 'auto'
): Promise< HTMLScriptElement > {
	if ( 'auto' === force ) {
		force = !! window.localStorage.getItem( 'the-modification-load-' + id );
	}

	return userActivation(
		() => loadScript( src, id ),
		autoStartTimeOut,
		force
	);
}

export function viewActivationLoadScript(
	selector: string,
	src: string,
	id: string,
	autoStartTimeOut = 0,
	force: boolean | 'auto' = 'auto',
	rootMargin = '600px 0px 600px 0px',
	threshold = [ 0.01 ]
) {
	if ( 'auto' === force ) {
		force = !! window.localStorage.getItem( 'the-modification-load-' + id );
	}

	return viewActivation(
		() => loadScript( src, id ),
		selector,
		autoStartTimeOut,
		force,
		rootMargin,
		threshold
	);
}
